export default {
  'Extract audio': '擷取音訊',
  'Mute': '靜音',
  'Split video and audio': '分離影片和音軌',
}